module.exports = __webpack_public_path__ + "static/media/ic-actions-searchReverse.fbedf85e.svg";